import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { PortfolioRequest, PortfolioResponse } from '../models';

export interface PortfolioApi {
  getPortfolio(request: PortfolioRequest): Observable<PortfolioResponse>;
}

export const PORTFOLIO_API = new InjectionToken<PortfolioApi>('PORTFOLIO_API');
